import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import NewAddressForm from '../Checkout/NewAddressForm'

const AddAddressModal = ({ isOpen, toggle, afterCreateAddress, addressType }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add Address</ModalHeader>
      <ModalBody>
        <NewAddressForm afterCreateAddress={afterCreateAddress} addressType={addressType} />
      </ModalBody>
    </Modal>
  )
}

export default AddAddressModal
